import { render, staticRenderFns } from "./CustomerAccountDeliver.vue?vue&type=template&id=88853f86&scoped=true"
import script from "./CustomerAccountDeliver.vue?vue&type=script&lang=js"
export * from "./CustomerAccountDeliver.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccountDeliver.vue?vue&type=style&index=0&id=88853f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88853f86",
  null
  
)

export default component.exports